import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgFinanciering = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F1F4FB"
      fillRule="evenodd"
      d="M8 34h20V12l-4-2-2-4H8v28"
      clipRule="evenodd"
    />
    <path
      fill="#E0E8F6"
      fillRule="evenodd"
      d="m22 6 2.98 2.98 2.99 2.99H22z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20 14.5H10v-1h10zM18 17.5h-8v-1h8zM19 20.5h-9v-1h9zM18 30.5h-8v-1h8z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M28 32a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M25.84 25.18h-3.56v-1h3.56zM25.84 23.47h-3.56v-1h3.56z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M27.012 19.5a4.2 4.2 0 0 1 2.065.545l-.494.87a3.2 3.2 0 0 0-1.581-.415h-.028a3.3 3.3 0 1 0 0 6.59h.029a3.2 3.2 0 0 0 1.59-.415l.494.87a4.2 4.2 0 0 1-2.076.545 4.298 4.298 0 0 1-4.157-5.991 4.3 4.3 0 0 1 4.158-2.599"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgFinanciering);

export default ForwardRef;
